export enum WebPaymentServiceType {
  Nexi = 0,
  PayPal = 1,
  Satispay = 2,
  Assiopay = 3,
  VendonGateway = 4,
}
